import httpService from './httpService'

// Public endpoints: no login needed
function buildQuery(params) {
  const query = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')
  return query ? `?${query}` : ''
}

async function getArticles(platform, context) {
  return httpService.apiRequest('get', `/help/articles${buildQuery({ platform, context })}`)
}

async function getArticle(slug) {
  return httpService.apiRequest('get', `/help/articles/${encodeURIComponent(slug)}`)
}

async function searchArticles(q, platform) {
  return httpService.apiRequest('get', `/help/search${buildQuery({ q, platform })}`)
}

export default {
  getArticles,
  getArticle,
  searchArticles,
}
